import { Component, AfterViewInit, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { GetLIMSDataService } from '../get-limsdata.service';
import { Subscription } from 'rxjs';
import { DESCMainService } from '../DESC.main.service';
import { GlobalDataService } from '../services/global-data.service';

@Component({
    selector: 'app-sampleselect',
    templateUrl: './sampleselect.component.html',
    styleUrls: ['./sampleselect.component.css']
})

export class SampleselectComponent implements AfterViewInit, OnInit, OnDestroy {
    NEXTenabled: boolean;
    public selectedExp: string;
    public selectedSite: string;
    public selectedHole: string;
    public expJSONArray;
    public siteJSONArray;
    public holeJSONArray;
    public error;
    public categories;
    public zerolevel;
    public attributes;
    public typesJSONArray;
    public categoryJSONArray;
    public assestJSONArray;
    public typeText;
    public categoryText;
    public mySpinner = false;
    subs: Subscription[] = [];

    constructor(private getLIMSData: GetLIMSDataService, private mainS: DESCMainService, public globals: GlobalDataService) { }

    ngAfterViewInit() {
        // settimeout is used to redisplay the component after the update since it is in a child component
        setTimeout(() => {
            this.selectedExp = this.mainS.activeExp;
            this.selectedSite = this.mainS.activeSite;
            this.selectedHole = this.mainS.activeHole;
            this.holeJSONArray = this.mainS.currentHoleList;
            this.setHoleDisplay();
        });
    }

    onExpChange() {
        this.selectedSite = null;
        this.selectedHole = null;
        this.holeJSONArray = new Array();
        this.setHoleDisplay();
        this.getSites(this.selectedExp);
    }

    onSiteChange() {
        this.setHoleDisplay();
        this.getHoles(this.selectedExp, this.selectedSite);
    }

    onHoleChange() {
        this.setHoleDisplay();
    }

    getExpeditions() {
        this.subs.push(this.getLIMSData.getExpeditions()
            .subscribe(
                res => this.expJSONArray = res,
                err => {
                    this.error = <any>err;
                },
                () => console.log('get Expeditions done.')
            ));
    }

    getSites(exp) {
        if (!exp) {
            return;
        }
        this.subs.push(this.getLIMSData.getSites(exp)
            .subscribe(
                res => this.siteJSONArray = res,
                err => {
                    this.error = <any>err;
                },
                () => console.log('get getSites done.')
            ));
    }

    getHoles(exp, site) {
        if (!site) {
            return;
        }
        this.subs.push(this.getLIMSData.getHoles(exp, site)
            .subscribe(
                res => this.holeJSONArray = res,
                err => {
                    this.error = <any>err;
                },
                () => console.log('get getHoles done.')
            ));
    }

    getCheckedValues(category) {
        this.categories = document.getElementsByClassName(category);
        this.typesJSONArray = [];
        for (let _i = 0; _i < this.categories.length; _i++) {
            this.zerolevel = this.categories[_i];
            if (this.zerolevel.checked === true) {
                this.typesJSONArray.push(this.zerolevel.attributes.value.value);
            }
        }
        return this.typesJSONArray;
    }

    setHoleDisplay() {
        if (this.selectedHole && this.selectedSite) { } else { }
    }

    assets: string;
    getAssets() {
        const self = this;
        document.getElementById('jonsID').innerHTML = ' ';
        this.mySpinner = true;
        if (!this.selectedExp) {
            alert('Must have a selected Expedition to run report');
            this.mySpinner = false;
            return;
        }
        let i = 0;
        this.typeText = [];
        this.categoryText = [];
        this.categoryJSONArray = [];
        this.categoryJSONArray =  this.getCheckedValues('category');
        if (this.categoryJSONArray.length === 0) {
            this.mySpinner = false;
            alert('You Must Have at Least 1 Category Type Selected');
            return;
        }
        this.categoryText = '';
        for (i = 0; i < this.categoryJSONArray.length; i++) {
            this.categoryText += this.categoryJSONArray[i] + ',';
        }
        this.categoryText = this.categoryText.slice(0, -1);
        this.assestJSONArray = [];
        this.assestJSONArray = this.getCheckedValues('asset');
        if (this.assestJSONArray.length === 0) {
            this.mySpinner = false;
            alert('You Must Have at Least 1 Asset Type Selected');
            return;
        }
        this.typeText = '';
        for (i = 0; i < this.assestJSONArray.length; i++) {
            this.typeText += this.assestJSONArray[i] + ',';
        }
        this.typeText = this.typeText.slice(0, -1);
        this.getLIMSData.resultReady.subscribe(s => {
            this.assets = s;
            document.getElementById('jonsID').innerHTML = this.assets;
            this.mySpinner = false;
            this.getLIMSData.resultReady.unsubscribe();
            this.getLIMSData.resultReady = new EventEmitter<string>();
        });
        this.getLIMSData.getReportAssets(this.selectedExp, this.selectedSite, this.selectedHole, this.typeText,
            this.categoryText, self.globals.username, self.globals.encryptedPassword);
    }

    ngOnInit() {
        if (this.mainS.activeHole) {
            this.selectedHole = this.mainS.activeHole;
        }
        if (this.mainS.activeExp) {
            this.selectedExp = this.mainS.activeExp;
        }
        this.getExpeditions();
    }

    ngOnDestroy() {
        this.mainS.activeExp = this.selectedExp;
        this.mainS.activeSite = this.selectedSite;
        this.mainS.activeHole = this.selectedHole;
        this.mainS.currentHoleList = this.holeJSONArray;
        this.subs.forEach(s => s.unsubscribe());
    }
}
